// Three learning/audience modes. Beginner is the default (house-mom test).
export const MODES = [
  {
    id: 'beginner',
    label: 'Beginner',
    tagline: 'Plain talk. Extra safety. No jargon.',
    color: 'lime',
  },
  {
    id: 'pro',
    label: 'Pro',
    tagline: 'Trade vocab. Torque specs. Code refs.',
    color: 'amber',
  },
  {
    id: 'student',
    label: 'Student',
    tagline: 'Why it works. Theory. Code intent.',
    color: 'sky',
  },
];

export const getMode = (id) => MODES.find((m) => m.id === id) || MODES[0];
